import colors from 'assets/styles/jsVariables/colors';

export default {
  PaymentButtonStyle: {
    backgroundColor: colors.lighterCyan,
    height: '45px',
    width: '200px',
    margin: 'auto',
    display: 'inline-block',
    '@media (max-width: 767px)': {
      display: 'block',
    }
  },
  PaymentButtonLabelStyle: {
    fontFamily: 'museosansrounded_500',
    fontSize: '14px',
    letterSpacing: '0.3px',
    textTransform: 'none'
  },
  PaymentCardStyle: {
    base: {
      color: colors.mediumGrey,
      fontSize: '18px',

      ':focus': {
        color: colors.mediumGrey,
        fontSize: '18px',
      },

      '::placeholder': {
        color: '#d9d9d9',
        fontSize: '18px',
      },

      ':focus::placeholder': {
        color: '#d9d9d9',
      },
    },
    invalid: {
      color: colors.carrotRed,

      ':focus': {
        color: colors.carrotRed
      },
      '::placeholder': {
        color: colors.carrotRed
      },
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/Payment/style.js